import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperClipRegularDiagonalIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.543 3.051a4.25 4.25 0 0 1 6.01 6.01l-5.303 5.306a2.75 2.75 0 0 1-3.891 0 2.75 2.75 0 0 1 0-3.89l4.953-4.95a.75.75 0 0 1 1.06 1.06l-4.95 4.949a1.25 1.25 0 1 0 1.769 1.769L14.492 8a2.75 2.75 0 1 0-3.887-3.89L4.95 9.767a4.25 4.25 0 0 0 6.009 6.01l4.419-4.416a.75.75 0 0 1 1.06 1.06l-4.42 4.418a5.75 5.75 0 0 1-8.131-8.131L9.543 3.05Z" })
});
export default SvgPaperClipRegularDiagonalIcon;
